import { render, staticRenderFns } from "./EditaCuenta.vue?vue&type=template&id=5fd99a85&scoped=true"
import script from "./EditaCuenta.vue?vue&type=script&lang=js"
export * from "./EditaCuenta.vue?vue&type=script&lang=js"
import style0 from "./EditaCuenta.vue?vue&type=style&index=0&id=5fd99a85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd99a85",
  null
  
)

export default component.exports